export const QUERY_KEY_PREFIX = 'query-integration-maintenance-config';
export const MUTATION_KEY = 'mutate-update-integration-maintenance-config';
